import { Link } from "react-router-dom";
import React, { useState } from "react";
import Swal from "sweetalert2";
import {
  addLeaveType,
  checkNomConge,
} from "../../../../services/RHService/LeaveTypeService";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

const AddLeave = () => {
  const [nomcongeError, setNomcongeError] = useState("");

  const [formData, setFormData] = useState({
    label: "",
    ispaid: true,
  });
  const handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    setFormData({
      ...formData,
      [name]: target.value,
    });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    const checknomCongeExist = await checkNomConge(
      formData.label,
      getCurrentUserId()
    );

    if (checknomCongeExist.success) {
      setNomcongeError("Nom de Congé déja existe");
      return;
    } else {
      setNomcongeError("");
    }
    if (!checknomCongeExist.success) {
      try {
        formData.idUser = getCurrentUserId();
        const response = await addLeaveType(formData);
        console.log(response.status);
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Type de contrat inséré avec succès",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Une erreur s'est produite lors de l'insertion de l'employé",
        });
      }
    }
  };
  return (
    <section className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0"> Ajouter un type de congé</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <i class="fa-solid fa-house"></i>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/settings/LeaveTypeList" style={{ color: "black" }}>
                    Liste des types de congé
                  </Link>
                </li>
                <li className="breadcrumb-item active">
                  Ajouter un type de congé
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div class="card-header">
                  <h4 class="card-title">Ajouter un type de congé</h4>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card-body">
                        <div className="form-group">
                          <label for="exampleInputPassword1">Nom</label>
                          <input
                            type="text"
                            className="form-control form-control-border"
                            value={formData.label}
                            onChange={handleInputChange}
                            name="label"
                            placeholder="Nom"
                          />{" "}
                        </div>
                        {nomcongeError && (
                          <p style={{ color: "red" }}>{nomcongeError}</p>
                        )}

                        <div className="form-group">
                          <label for="exampleInputPassword1">
                            Type de congé
                          </label>
                          <select
                            className="custom-select form-control-border"
                            value={formData.ispaid ? "true" : "false"}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                ispaid: e.target.value === "true",
                              })
                            }
                            name="ispaid"
                          >
                            <option value="true">Payé</option>
                            <option value="false">Non payé</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <button
                      type="submit"
                      className="btn btn-dark col-md-3 float-right"
                      style={{ width: "auto" }}
                    >
                      Confirmer
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};
export default AddLeave;
